export default "__VITE_ASSET__DLoQONJE__"